interface PaginationProps {
  currentPage: number;
  totalPages: number | null;
  total: number | null;
  pageSize: number;
  canGoNext: boolean;
  canGoPrevious: boolean;
  onPageChange: (direction: 'next' | 'prev' | 'first' | 'last') => void;
  onPageSizeChange: (size: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  total,
  pageSize,
  canGoNext,
  canGoPrevious,
  onPageChange,
  onPageSizeChange,
}: PaginationProps) {
  const startItem = currentPage * pageSize + 1;
  const endItem = total !== null && total !== undefined
    ? Math.min((currentPage + 1) * pageSize, total)
    : (currentPage + 1) * pageSize;

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-4 py-3 bg-white border-t border-gray-200">
      <div className="flex items-center gap-2 text-sm text-gray-700">
        <span>
          Showing <span className="font-medium">{startItem}</span> to{' '}
          <span className="font-medium">{endItem}</span>
          {total !== null && total !== undefined && (
            <> of <span className="font-medium">{total.toLocaleString()}</span> results</>
          )}
        </span>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange('first')}
          disabled={!canGoPrevious}
          className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white"
          aria-label="First page"
        >
          First
        </button>
        <button
          onClick={() => onPageChange('prev')}
          disabled={!canGoPrevious}
          className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white"
          aria-label="Previous page"
        >
          Previous
        </button>
        
        <span className="px-4 py-1.5 text-sm font-medium text-gray-700">
          Page {currentPage + 1}
          {totalPages !== null && totalPages !== undefined && ` of ${totalPages}`}
        </span>

        <button
          onClick={() => onPageChange('next')}
          disabled={!canGoNext}
          className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white"
          aria-label="Next page"
        >
          Next
        </button>
        
        <div className="flex items-center gap-2 ml-2 pl-2 border-l border-gray-300">
          <label htmlFor="page-size" className="text-sm text-gray-700">
            Rows per page:
          </label>
          <select
            id="page-size"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            {[10, 20, 30, 50, 100].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

